import { HiSparkles, HiXMark } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";

interface WelcomeStampBannerProps {
  onClose: () => void;
}

const WelcomeStampBanner = ({ onClose }: WelcomeStampBannerProps) => {
  const navigate = useNavigate();

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div className="sticky top-0 z-40 px-4 py-2 bg-white border-b border-gray-100">
      <div className="relative w-full rounded-2xl bg-gradient-to-r from-[#eff4ff] via-white to-[#f7fbff] border border-[#dbe6ff] p-4 shadow-[0_10px_25px_rgba(21,98,252,0.08)] overflow-hidden animate-bounce-up-down">
        <button
          type="button"
          onClick={handleClose}
          className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center rounded-full bg-gray-200/80 hover:bg-gray-300/80 text-gray-600 hover:text-gray-800 transition-colors z-20"
        >
          <HiXMark className="w-4 h-4" />
        </button>
        <div className="absolute -right-4 -top-4 w-28 h-28 bg-[#1562fc]/10 blur-3xl" />
        <div className="flex items-start gap-3 z-10 relative">
          <div className="w-10 h-10 rounded-full bg-[#1562fc] flex items-center justify-center text-white shadow-lg">
            <HiSparkles className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <p className="text-xs font-semibold text-[#1562fc] uppercase tracking-wide">
              Welcome Benefit
            </p>
            <p className="text-lg font-extrabold text-gray-900 mt-1">
              웰컴 스탬프 받아가세요!
            </p>
            <p className="text-xs text-gray-600 mt-1 leading-snug">
              스탬프 10개 모으면 1,000원 할인 쿠폰으로 교환합니다.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={() => navigate("/welcome-stamp")}
          className="mt-4 w-full bg-[#1562fc] text-white font-semibold py-3 rounded-xl text-sm shadow-md hover:bg-[#0f4dcf] transition-colors"
        >
          혜택 보기
        </button>
      </div>
    </div>
  );
};

export default WelcomeStampBanner;
